import React, { useEffect, useState } from 'react';

import QRCode from 'qrcode.react';
import { changeEUDIURIAction, useStateValue } from '../../hooks/useState';

import { useWideScreen } from '../../hooks/useWide';
import { getServerEnvironment } from '../../helper/getServerEnvironment';

import { Loader } from '../Loader/Loader';
import { getDirectLink } from 'src/helper/getDirectLink';
import { postStartEUDI } from 'src/api/postStartEUDI';

export const QRComponent = () => {
  const isWide = useWideScreen();

  const [
    { uuid, responseURI, deliveryPreview, isEUDISupported, eudiURI },
    dispatch
  ]: any = useStateValue();

  const [isEUDIQRCode, setIsEUDIQRCode] = useState(false);
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (uuid || deliveryPreview.deliveryID) {
      const env = getServerEnvironment();

      const endpoint = getDirectLink({
        uuid,
        responseURI,
        env,
        deliveryPreview,
        referral: 'qr'
      });

      setUrl(endpoint);
    }
  }, [uuid, responseURI, deliveryPreview?.deliveryID]);

  if (!isWide) {
    return null;
  }

  return (
    <div
      style={{
        background: 'white'
      }}
    >
      {url ? (
        <>
          <QRCode
            style={{
              maxWidth: 220,
              maxHeight: 220
            }}
            value={isEUDIQRCode && eudiURI ? eudiURI : url}
            size={220}
            fgColor={'#2B2B2E'}
          />
          {!!isEUDISupported && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              style={{
                fontSize: 14,
                marginTop: 10,
                color: '#2B2B2E',
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
              onClick={() => {
                if (isEUDIQRCode) {
                  setIsEUDIQRCode(false);
                  return;
                }

                if (eudiURI) {
                  setIsEUDIQRCode(true);
                } else {
                  postStartEUDI({
                    uuid
                  }).then(({ url }) => {
                    if (url) {
                      dispatch(
                        changeEUDIURIAction({
                          eudiURI: url
                        } as any)
                      );
                      setIsEUDIQRCode(true);
                    }
                  });
                }
              }}
            >
              {isEUDIQRCode
                ? 'Switch to Nect Ident QR Code'
                : 'Switch to EUDI Flow QR Code'}
            </a>
          )}
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};
